(function () {
    'use strict';

    angular.module("imApp").factory("textileModelCategory6LangService", ['$ihttp', function ($ihttp) {
        let service = {
            listTextileModelCategory6Languages: function (parms) {
                return $ihttp.post({
                    method: 2693,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2694,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
